export default __webpack_public_path__ + "e443f36d9facfefc292df1d293814077.svg";